import React from "react";
import {
  InputElementUnion,
  IYearMonthInputElement,
} from "@graffer-inc/form-schema";

import { CommonPropertiesEditor } from "../common-properties-editor";
import { YearMonthInputValidationEditor } from "./year-month-input-validation-editor";

type Props = {
  element: IYearMonthInputElement;
  onElementUpdate: (arg: InputElementUnion) => void;
};

export const YearMonthInputEditor: React.FC<Props> = ({
  element,
  onElementUpdate,
}) => {
  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <hr />
      <YearMonthInputValidationEditor element={element} />
    </>
  );
};
